import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNfc1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNfc1"><Path d="M6.5 7.19254C7.68877 8.46865 8.41153 10.1533 8.41153 12C8.41153 13.8467 7.68877 15.5313 6.5 16.8075M9.94361 4.71311C11.6675 6.68358 12.7058 9.22539 12.7058 12C12.7058 14.7746 11.6675 17.3164 9.94361 19.2869M13.0173 2.5C15.4972 5.03803 17 8.36176 17 12C17 15.6382 15.4972 18.962 13.0173 21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconNfc1;
